angular.module('app.entity.service', [
    'gettext',
    'ui.router',
    'inetsys.tools',
    'sharecrf-url',
    'app.entity.common',
    'inetsys.conditions',
]);
